import workspaceQuery from 'graphql/queries/product/LuckinsVatRateWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/LuckinsVatRateListQuery.graphql';
import instance from 'graphql/queries/product/LuckinsVatRateQuery.graphql';
import fragment from 'graphql/fragments/product/LuckinsVatRateFragment.graphql';
import update from 'graphql/mutations/product/LuckinsVatRateMutation.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const LuckinsVatRate = {
  type: 'LuckinsVatRate',
  title: 'Luckins Vat Rates',
  formTitle: 'Luckins Vat Rate',
  workspaceUrl: '/Products/Luckins/LuckinsVatRate/Workspace/',
  formUrl: '/Products/Luckins/LuckinsVatRate/Details/',
  workspace: workspaceQuery,
  list: listQuery,
  instance,
  update,
  fragment,
  screenReference: 'LUCKINS_VAT_RATES',
  operations: ALLOW_VIEW | ALLOW_EDIT,
};

export default LuckinsVatRate;
